<script>

  export default {
    methods: {
      dropAreaDrop(e) {
        e.preventDefault();
        let file = e.dataTransfer.files[0], reader = new FileReader();
        let vm = this;

        reader.onload = function(event) {
          // console.log(event.target.result);
          vm.$emit("get_drop", event.target.result)
        };

        if (file.type !== "text/plain" && file.name.substring(file.name.lastIndexOf(".")) !== ".scl") return
        reader.readAsText(file);
      },
      loadPresetChanged(e) {
        let file = e.srcElement.files[0], reader = new FileReader();
        let vm = this;
        reader.onload = function(event) {
          // console.log(event.target.result);
          vm.$emit("get_drop", event.target.result)
        };


        if (file.type !== "text/plain") return
        reader.readAsText(file);
        document.getElementById("load_preset").value="";
      }
    },
    props: {
      name: {
        type: String,
        default: "Drop preset here"
      }
    }
  }
</script>

<template>
  <label class="fileDropArea" for="load_preset" @dragover="(e) => e.preventDefault()" @drop="(e) => dropAreaDrop(e)">
    <span>{{this.name}}</span>
  </label>
  <input type="file" id="load_preset" style="display: none" accept=".txt,.scl,text/plain" @change="(e) => loadPresetChanged(e)"/>
</template>

<style scoped>
.fileDropArea {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  border-style: dashed;
  border-color: rgb(0, 114, 245);
  padding: 1%;
  border-radius: 5px;
  color: rgb(0, 114, 245);
}

.fileDropArea span {
  margin: 0;



}
</style>
